module.exports = __webpack_public_path__ + "img/9ea2301.png";